import reducer from "./reducers";

import * as locationAction from "./actions";

export { locationAction };

export default reducer;
